import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Positions scatter across the lower half of the hero photograph, clear of the
 * headline above. Percentages keep them anchored as the image is cropped
 * across breakpoints.
 */
const stamps = [{
  left: '13%',
  top: '64%',
  rotate: -11
}, {
  left: '83%',
  top: '72%',
  rotate: 7
}, {
  left: '31%',
  top: '88%',
  rotate: -6
}];
const easeOut = [0.23, 1, 0.32, 1] as const;
export function HeroPaidStamps() {
  const prefersReducedMotion = useReducedMotion();
  const [stamped, setStamped] = useState(prefersReducedMotion ? 3 : 0);
  useEffect(() => {
    if (prefersReducedMotion) return;
    const isComplete = stamped >= stamps.length;
    const timer = window.setTimeout(() => setStamped(isComplete ? 0 : stamped + 1), isComplete ? 3200 : stamped === 0 ? 1000 : 850);
    return () => window.clearTimeout(timer);
  }, [stamped, prefersReducedMotion]);
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden select-none md:block" data-id="element-79" data-mp="1l8gkxe1sxcmm">
      {stamps.map((stamp, index) => {
      const isVisible = index < stamped;
      return <motion.span key={index} initial={false} animate={isVisible ? {
        opacity: 0.9,
        scale: 1,
        rotate: stamp.rotate
      } : {
        opacity: 0,
        scale: 1.45,
        rotate: stamp.rotate
      }} transition={{
        duration: 0.24,
        ease: easeOut
      }} style={{
        left: stamp.left,
        top: stamp.top
      }} className="absolute -translate-x-1/2 -translate-y-1/2 border-[3px] border-[#31C48D] px-3 py-1 lg:border-4 lg:px-4 lg:py-1.5" data-id="element-80" data-mp="2s4jlr4i72zu3" data-mpi={index}>
            <span className="font-display block text-lg font-extrabold uppercase tracking-[0.22em] text-[#31C48D] lg:text-2xl" data-id="element-81" data-mp="3fu47tw9nad7l">
              Paid
            </span>
          </motion.span>;
    })}
    </div>;
}